import Observable from '../lib/Observable.js';
import Promise from '../lib/Promise.js';

class Dialog {
    static create({id}) {
        return new Dialog({id});
    }

    static hidden(id) {
        return !this.visible(id);
    }

    static hide() {
        $('.dialog-visible').removeClass('dialog-visible');
    }

    static visible(id) {
        return $(`#${id}`).hasClass('dialog-visible');
    }

    constructor({id, autoInitEvents = true}) {
        Observable.apply(this);

        this.el = $(`#${id}`);
        this.closeButton = this.find('.dialog-close');
        this.autoHide = this.el[0].getAttribute('auto-hide') === 'true';

        if (autoInitEvents) {
            this.initEvents();
        }
    }

    initEvents() {
        this.getEl().on('formError', () => this.performLayout());
        this.getEl().on('fieldError', () => this.performLayout());

        this.closeButton.click(() => this.onHideGesture());
    }

    clearErrors() {
        this.find('[aria-invalid]').removeAttr('aria-invalid').removeAttr('aria-errormessage');
        this.find('.error').remove();
    }

    find(selector) {
        return this.getEl().find(selector);
    }

    getEl() {
        return this.el;
    }

    hide() {
        this.setVisible(false);
        this.trigger('hide');
    }

    onEscapeKeydown() {
        this.onHideGesture();
    }

    onHideGesture() {
        this.maybeTrigger('hideGesture');

        if (this.autoHide) {
            this.hide();
        }
    }

    performLayout() {
        var el = this.getEl(),
            viewport = $(window),
            body = $(document.body),
            scrollTop = viewport.scrollTop(),
            pageContent = document.querySelector('.page-content'),
            pageFooter = document.querySelector('.page-footer'),
            offset;

        body.css('height', '');
        body.css('padding-top', '');

        if (el.is('.dialog-stretch')) {
            el.css('height', Math.max(400, pageFooter.offsetTop - el.get(0).offsetTop - 40));
        }

        offset = pageFooter.offsetTop - pageContent.offsetTop - pageContent.offsetHeight;

        if (offset < 10) {
            offset = Math.max(0, -offset);

            body.css('height', (document.body.offsetHeight + offset + 20));
        }
        else {
            body.css('padding-top', Math.floor(offset / 2));
        }

        viewport.scrollTop(scrollTop);
    }

    setVisible(visible) {
        this.getEl().toggleClass('dialog-visible', visible);
    }

    show() {
        this.trigger('beforeShow');

        this.setVisible(true);
        this.performLayout();
        this.trigger('show');

        return Promise.create(resolve => this.onNext('hide', resolve));
    }
}

export default Dialog;
